module.exports = __webpack_public_path__ + "static/media/duanwuBg2.6692652e.png";